import React, {} from 'react';
import {injectIntl} from "react-intl";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import ARButton from "./components/ar3d/ARButton";

const SquareFootageToolAR = (props) => {
  const {match} = props;
  const file = match.params ? match.params.file : null;
  const url = 'https://s3.amazonaws.com/qc-3dfiles/composed/' + file + '.glb'

  return (
    <div className="sqft">
      <div className="ar-page">
        {/*<img src={qrImage} alt='' />*/}
        <ARButton url={url}/>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  return {
    visualizersLoaded: store.serverState.visualizersLoaded,
  };
};

const mapDispatchToProps = {
};

export default withRouter(
  injectIntl(
    connect(mapStateToProps, mapDispatchToProps)(SquareFootageToolAR)
  )
);
